export const IMAGE_ALTS_RU = {
  AVATAR: 'Аватар',
};
